export default __webpack_public_path__ + "static/media/upload-scene.9c017f88.webp";